import { Container, Flex, Section } from "@radix-ui/themes";
import { FC, JSX } from "react";
import { Link, useLocation } from "react-router-dom";
import { getNavRoutes } from "@/routes/navRoutes";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import User from "../User/User";

const Header: FC = (): JSX.Element => {
  const user = useCurrentUserProfile((s) => s.user);
  const navRoutes = getNavRoutes(user);
  const location = useLocation();
  const currentRoute = location.pathname;

  return (
    <header>
      <Container px={{ initial: "4", lg: "0" }}>
        <Section size="1">
          <Flex justify="between" align="center">
            <Flex direction="row" gap="5" className="nav">
              {navRoutes.map((route) => (
                <Link
                  key={route.path}
                  to={route.path}
                  className={
                    currentRoute === route.path ||
                    currentRoute.includes(route.path + "/")
                      ? "nav__item--active"
                      : "nav__item"
                  }
                >
                  {route.label}
                </Link>
              ))}
            </Flex>
            <User />
          </Flex>
        </Section>
      </Container>
    </header>
  );
};

export default Header;
